import {
  useTranslate,
  IResourceComponentsProps,
  useNavigation,
} from "@pankod/refine-core";
import {
  List,
  Table,
  TextField,
  useTable,
  getDefaultSortOrder,
  Space,
  EditButton,
  DeleteButton,
  Button,
  Form,
  Input,
  Icons,
} from "@pankod/refine-antd";
import { IEquipment, IPartner, IPartnerCategory } from "interfaces";
import { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { CheckOutlined, CloseOutlined } from "@ant-design/icons";

export const EquipmentList: React.FC<IResourceComponentsProps> = () => {
  const t = useTranslate();
  const { create, list } = useNavigation()

  const [ inputValue, setInputValue ] = useState("")

  const meta = inputValue == '' ? {} : { search: inputValue }

  const { tableProps, sorter, searchFormProps } = useTable<IEquipment>({
    initialPageSize: 20,
    metaData: meta,
    initialSorter: [
      {
        field: "label",
        order: "asc",
      },
    ],
  });

  return (
    <List
      title={t("menu.equipments")}
      pageHeaderProps={{
        extra: [
          // <Button key="page_header_extra_2" onClick={() => list("partnercategories")}>{`${t('posts.fields.category.title')}s`}</Button>,
          <Button key="page_header_extra_1" onClick={() => create('equipments')}>+</Button>,
        ],
      }}

    >
      <Form 
        onValuesChange={() => searchFormProps.form?.submit()}
        key="form"
        {...searchFormProps}
      >
        <Form.Item label="" name="search_name">
          <Input
              autoComplete="off"
              placeholder="ID, Title, Content, etc."
              prefix={<Icons.SearchOutlined />}
              onChange={e => setInputValue(e.target.value)}
          />
        </Form.Item>
      </Form>

      <Table {...tableProps} 
        pagination={{
          ...tableProps.pagination,
          showSizeChanger: true,
        }}
        rowKey="id"
        >
        <Table.Column
          dataIndex="label"
          key="label"
          title={t("customers.lname")}
          render={(value) => <TextField value={value} />}
          defaultSortOrder={getDefaultSortOrder("label", sorter)}
          sorter
        />
        <Table.Column
          dataIndex="fa_icon"
          key="fa_icon"
          title={`Fa ${t("icon")}`}
          render={(value) => <FontAwesomeIcon size="2x" icon={value} />}
          defaultSortOrder={getDefaultSortOrder("fa_icon", sorter)}
          sorter
        />
        {/* <Table.Column
          dataIndex="display_order"
          key="display_order"
          title={t("display_order")}
          render={(value) => <TextField value={value} />}
          sorter
        /> */}
        <Table.Column
          dataIndex="is_in_room_preview"
          key="is_in_room_preview"
          title={t("is_in_room_preview")}
          render={(value) => value? <CheckOutlined style={{ color: "green" }} /> : <CloseOutlined style={{ color: "red" }} />}
          defaultSortOrder={getDefaultSortOrder("is_in_room_preview", sorter)}
          sorter
        />
        <Table.Column
          dataIndex="is_in_filter"
          key="is_in_filter"
          title={t("is_in_filter")}
          render={(value) => value? <CheckOutlined style={{ color: "green" }} /> : <CloseOutlined style={{ color: "red" }} />}
          defaultSortOrder={getDefaultSortOrder("is_in_filter", sorter)}
          sorter
        />
        <Table.Column<IPartner>
          title={t("table.actions")}
          dataIndex="actions"
          render={(_, record) => (
            <Space>
              <EditButton hideText size="small" recordItemId={record.id} />
              <DeleteButton hideText size="small" recordItemId={record.id} />
            </Space>
          )}
        />
      </Table>
    </List>
  );
};
